App.TimetableEditorComponent = Ember.Component.extend
  classNames: [ 'timetable-editor-component' ]

  # Оригинальный массив элементов расписания
  timetables: null

  # Шаг, с которым отображаются времена в подсказках
  granulation: 30

  # Только то расписание, которое относится к дням недели и
  # не покрывает "специальные" дни
  sortedWeekTimetables: (->
    Em.ArrayProxy.createWithMixins Em.ArrangeableMixin,
      content: @get('timetables')
      sortProperties: [ 'day' ]
      sortFunction: (a, b) ->
        Em.compare(arguments...)
      filterProperties: [
        [ 'date', (v) -> v ]
      ]
  ).property('timetables')

  # Сгруппированные по дням элементы расписания
  groupedTimetables: (->
    Em.ArrayProxy.createWithMixins Em.GroupableMixin,
      groupBy: 'day'
      content: @get('sortedWeekTimetables')
  ).property('sortedWeekTimetables')
